var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedrooms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 13.373v3.843c0 .208.14.378.313.378h.286c.21 0 .387-.147.465-.38l.5-1.508H17.21l.5 1.508c.079.233.256.38.465.38h.287c.172 0 .313-.17.313-.378v-3.843M1.565 2.114v10.612h.938V6.042c0-.416.282-.755.626-.755h5.163c.345 0 .626.34.626.755v6.684h.939V6.042c0-.416.28-.755.625-.755h5.163c.345 0 .626.34.626.755v6.684h.939V2.114c.28-.196.469-.562.469-.981 0-.626-.42-1.133-.939-1.133-.518 0-.939.507-.939 1.133 0 .419.19.785.47.981v.53H2.503v-.53c.281-.196.47-.562.47-.981C2.973.507 2.553 0 2.034 0c-.518 0-.938.507-.938 1.133 0 .419.188.785.469.981"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.774 14.195v-4.154c0-.832-.562-1.51-1.252-1.51H1.252C.562 8.53 0 9.208 0 10.04v4.154c0-.208.14-.378.313-.378"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h19.862v18H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedrooms);
export default __webpack_public_path__ + "static/media/bedrooms.2895805b26b68f1a8d09f08fa06ad2a9.svg";
export { ForwardRef as ReactComponent };